/**
 * Элемент Motivation — шестиугольник с иконкой (Goal, Driver, Outcome, ValueStream и др.).
 * Форма: getHexagonPath (cut = min(w,h)*0.15). При ресайзе path пересчитывается в onNodeResize (PATH_BASED_SHAPES).
 */
import ElementNodeTypeBase from './ElementNodeTypeBase';
import {ARCHIMATE_PICTO_ICON_CORNER} from '../modelerX6/constants';
import {getHexagonPath} from '../draw/ArchimateRendererUtil';
import {textAlignToLabelAttrs} from './textAlignUtil';

export default class MotivationElementNodeType extends ElementNodeTypeBase {
	static get typeName() {
		return 'Element';
	}

	get shapeId() {
		return 'archimate:element-hexagon';
	}

	buildNodeConfig(pathMap, options = {}) {
		const {id, x = 0, y = 0, width, height, label, fillColor, lineColor, textAlign} = options;
		const align = textAlignToLabelAttrs(textAlign, {reserveForIcon: true});
		const w = width ?? this.defaultSize.width;
		const h = height ?? this.defaultSize.height;
		const iconRef = this.iconRef;
		if (!iconRef) {
			throw new Error(`Unsupported element type: ${this.constructor.typeName}`);
		}
		const iconBoxW = Math.round(0.22 * w);
		const iconBoxH = Math.round(0.45 * h);
		const iconPath = pathMap.getScaledPath(iconRef, {
			xScaleFactor: 1,
			yScaleFactor: 1,
			containerWidth: iconBoxW,
			containerHeight: iconBoxH,
			position: {mx: 0, my: 0},
		});
		const fillColorFinal = this.getDefaultFillColor(fillColor);
		const lineColorFinal = this.getDefaultLineColor(lineColor);
		const hexagonPath = getHexagonPath({x: 0, y: 0, width: w, height: h});

		const nodeAttrs = {
			body: {
				d: hexagonPath,
				fill: fillColorFinal,
				stroke: lineColorFinal,
				strokeWidth: 1,
			},
			icon: {
				d: iconPath,
				fill: fillColorFinal,
				stroke: lineColorFinal,
				strokeWidth: 0.8,
				...ARCHIMATE_PICTO_ICON_CORNER,
			},
			label: {
				text: label ?? '',
				...align,
				textWrap: {width: -40, height: '100%', ellipsis: true, breakWord: true},
			},
		};

		return {
			id,
			x,
			y,
			width: w,
			height: h,
			shape: this.shapeId,
			attrs: nodeAttrs,
			data: {iconRef},
		};
	}
}
